import { Component, Input } from '@angular/core';
import { FieldComponent } from 'tuain-ng-forms-lib';

@Component({
  selector: 'app-message',
  templateUrl: './app-message.component.html',
})
export class AppMessageComponent extends FieldComponent {
  @Input() labelType: any;
}
